import { QuestDefinition } from './types';

/**
 * Quest definition for the Wall Create tool (WallCreateTool / 'wall_create').
 *
 * Suggestion mode (no wall sketch yet) mirrors the outline-create flow: Redux
 * room selection drives a live outer-wall + wall-sketch preview and Enter
 * commits both. Once the floor has a wall sketch the tool switches to draw
 * mode ('draw'/'drawing' phases) where every drag creates walls.
 */
export const wallCreateQuest: QuestDefinition = {
  toolName: 'wall_create',
  states: {
    idle: 'select rooms to include, then press Enter to create the outer wall and walls',
    has_selection: 'press Enter to create the outer wall and walls, or click more rooms to add them',
    draw: 'drag to draw a wall · drag from a node or wall to branch · right-click deletes',
    drawing: 'drag to draw a wall · drag from a node or wall to branch · right-click deletes · Enter to save · Esc to cancel',
  },
  defaultKey: 'select rooms to include, then press Enter to create the outer wall and walls',
};
